// ── MC colour-code renderer ───────────────────────────────────
const MC_COLORS = {
  '0':'#000000','1':'#0000AA','2':'#00AA00','3':'#00AAAA',
  '4':'#AA0000','5':'#AA00AA','6':'#FFAA00','7':'#AAAAAA',
  '8':'#555555','9':'#5555FF','a':'#55FF55','b':'#55FFFF',
  'c':'#FF5555','d':'#FF55FF','e':'#FFFF55','f':'#FFFFFF',
};

const MC_NAMED_COLORS = {
  black: '#000000', dark_blue: '#0000AA', dark_green: '#00AA00',
  dark_aqua: '#00AAAA', dark_red: '#AA0000', dark_purple: '#AA00AA',
  gold: '#FFAA00', gray: '#AAAAAA', dark_gray: '#555555',
  blue: '#5555FF', green: '#55FF55', aqua: '#55FFFF',
  red: '#FF5555', light_purple: '#FF55FF', yellow: '#FFFF55',
  white: '#FFFFFF',
};

function hexToRgb(hex) {
  const h = hex.replace('#', '');
  return [parseInt(h.slice(0,2),16), parseInt(h.slice(2,4),16), parseInt(h.slice(4,6),16)];
}
function rgbToHex(r,g,b) {
  return '#'+[r,g,b].map(v=>Math.round(Math.max(0,Math.min(255,v))).toString(16).padStart(2,'0')).join('');
}
function lerpColor(c1, c2, t) {
  const [r1,g1,b1]=hexToRgb(c1), [r2,g2,b2]=hexToRgb(c2);
  return rgbToHex(r1+(r2-r1)*t, g1+(g2-g1)*t, b1+(b2-b1)*t);
}
function interpolateGradient(stops, t) {
  if (stops.length < 2) return stops[0] || '#AAAAAA';
  const seg = Math.min(Math.floor(t*(stops.length-1)), stops.length-2);
  const segT = t*(stops.length-1) - seg;
  return lerpColor(stops[seg], stops[seg+1], segT);
}
function resolveTagColor(tag) {
  if (MC_NAMED_COLORS[tag]) return MC_NAMED_COLORS[tag];
  if (/^#[0-9a-f]{6}$/i.test(tag)) return tag;
  return null;
}


function parseMcText(text) {
  if (!text) return [{ text: '', color: null, bold: false, italic: false, underline: false, strike: false }];

  // Legacy § format
  if (!text.includes('<')) {
    const parts = [];
    let color = null, bold = false, italic = false, underline = false, strike = false;
    const re = /§([0-9a-frlonmkA-FRLONMK])/g;
    let last = 0, m;
    while ((m = re.exec(text)) !== null) {
      if (m.index > last) parts.push({ text: text.slice(last, m.index), color, bold, italic, underline, strike });
      const c = m[1].toLowerCase();
      if (MC_COLORS[c]) { color = MC_COLORS[c]; bold = false; italic = false; underline = false; strike = false; }
      else if (c === 'l') bold = true;
      else if (c === 'o') italic = true;
      else if (c === 'n') underline = true;
      else if (c === 'm') strike = true;
      else if (c === 'r') { color = null; bold = false; italic = false; underline = false; strike = false; }
      last = re.lastIndex;
    }
    if (last < text.length) parts.push({ text: text.slice(last), color, bold, italic, underline, strike });
    return parts;
  }

  // Adventure API tag format
  const TAG_RE = /<([^>]+)>/g;
  const tokens = [];
  let lastIdx = 0, match;
  while ((match = TAG_RE.exec(text)) !== null) {
    if (match.index > lastIdx) tokens.push({ type: 'text', value: text.slice(lastIdx, match.index) });
    const t = match[1];
    if (t.startsWith('/')) tokens.push({ type: 'close', tag: t.slice(1).toLowerCase() });
    else tokens.push({ type: 'open', tag: t.toLowerCase() });
    lastIdx = TAG_RE.lastIndex;
  }
  if (lastIdx < text.length) tokens.push({ type: 'text', value: text.slice(lastIdx) });

  const styleStack = [{ color: null, bold: false, italic: false, underline: false, strike: false }];
  const segments = [];
  let gradientStops = null, gradientBuf = [];

  const curStyle = () => styleStack[styleStack.length - 1];

  for (const token of tokens) {
    if (token.type === 'text') {
      const s = curStyle();
      if (gradientStops) {
        gradientBuf.push({ text: token.value, bold: s.bold, italic: s.italic, underline: s.underline, strike: s.strike });
      } else {
        segments.push({ text: token.value, ...s });
      }
    } else if (token.type === 'open') {
      const tag = token.tag;
      if (tag.startsWith('gradient:')) {
        const stops = tag.split(':').slice(1).map(c => c.startsWith('#') ? c : '#' + c).filter(c => /^#[0-9a-f]{3,6}$/i.test(c));
        gradientStops = stops.length ? stops : ['#AAAAAA', '#FFFFFF'];
        gradientBuf = [];
      } else {
        const prev = curStyle();
        const next = { ...prev };
        const col = resolveTagColor(tag);
        if (col) next.color = col;
        else if (tag === 'bold') next.bold = true;
        else if (tag === 'italic') next.italic = true;
        else if (tag === 'underlined') next.underline = true;
        else if (tag === 'strikethrough') next.strike = true;
        else if (tag === 'reset') { next.color = null; next.bold = false; next.italic = false; next.underline = false; next.strike = false; }
        styleStack.push(next);
      }
    } else if (token.type === 'close') {
      if (token.tag === 'gradient') {
        if (gradientStops && gradientBuf.length) {
          const allText = gradientBuf.map(s => s.text).join('');
          const len = allText.length;
          let ci = 0;
          for (const seg of gradientBuf) {
            for (const ch of seg.text) {
              const t = len > 1 ? ci / (len - 1) : 0;
              segments.push({ text: ch, color: interpolateGradient(gradientStops, t), bold: seg.bold, italic: seg.italic, underline: seg.underline, strike: seg.strike });
              ci++;
            }
          }
        }
        gradientStops = null;
        gradientBuf = [];
      } else if (styleStack.length > 1) {
        styleStack.pop();
      }
    }
  }

  // Flush unclosed gradient
  if (gradientStops && gradientBuf.length) {
    const allText = gradientBuf.map(s => s.text).join('');
    const len = allText.length;
    let ci = 0;
    for (const seg of gradientBuf) {
      for (const ch of seg.text) {
        const t = len > 1 ? ci / (len - 1) : 0;
        segments.push({ text: ch, color: interpolateGradient(gradientStops, t), bold: seg.bold, italic: seg.italic, underline: seg.underline, strike: seg.strike });
        ci++;
      }
    }
  }

  return segments.length ? segments : [{ text: text, color: null, bold: false, italic: false, underline: false, strike: false }];
}

export function McText({ text, defaultColor = '#AAAAAA' }) {
  const parts = parseMcText(text);
  return (
    <>
      {parts.map((p, i) => (
        <span key={i} style={{
          color: p.color ?? defaultColor,
          fontWeight: p.bold ? 'bold' : undefined,
          fontStyle: p.italic ? 'italic' : undefined,
          textDecoration: [p.underline && 'underline', p.strike && 'line-through'].filter(Boolean).join(' ') || undefined,
        }}>{p.text}</span>
      ))}
    </>
  );
}

